export const black = '#000'
// export const nearBlack = '#111'
export const nearBlack = '#1A1A1A'

export const darkGray ='#4A4A4A'
export const midGray ='#555'
export const gray = '#777'
export const silver = '#999'
// export const lightSilver = '#aaa'
export const lightSilver = '#9B9B9B'
export const moonGray = '#ccc'
export const lightGray = '#eee'
export const nearWhite = '#f4f4f4'
export const white = '#fff'
export const almostWhite = '#F6F6F6'

export const transparent ='transparent'

export const black90 = 'rgba(0,0,0,.9)'
export const black80 = 'rgba(0,0,0,.8)'
export const black70 = 'rgba(0,0,0,.7)'
export const black60 = 'rgba(0,0,0,.6)'
export const black50 = 'rgba(0,0,0,.5)'
export const black40 = 'rgba(0,0,0,.4)'
export const black30 = 'rgba(0,0,0,.3)'
export const black20 = 'rgba(0,0,0,.2)'
export const black10 = 'rgba(0,0,0,.1)'
export const black05 = 'rgba(0,0,0,.05)'
export const black025 = 'rgba(0,0,0,.025)'
export const black0125 = 'rgba(0,0,0,.0125)'

export const white90 = 'rgba(255,255,255,.9)'
export const white80 = 'rgba(255,255,255,.8)'
export const white70 = 'rgba(255,255,255,.7)'
export const white60 = 'rgba(255,255,255,.6)'
export const white50 = 'rgba(255,255,255,.5)'
export const white40 = 'rgba(255,255,255,.4)'
export const white30 = 'rgba(255,255,255,.3)'
export const white20 = 'rgba(255,255,255,.2)'
export const white15 = 'rgba(255,255,255,.15)'
export const white10 = 'rgba(255,255,255,.1)'
export const white05 = 'rgba(255,255,255,.05)'
export const white025 = 'rgba(255,255,255,.025)'
export const white0125 = 'rgba(255,255,255,.0125)'
export const blueKing = '#041bf3'

export const darkRed =  '#e7040f'
export const red =  '#ff4136'
export const lightRed = '#ff725c'
export const orange = '#ff6300'
export const gold = '#ffb700'
// export const yellow = '#ffd700'
export const yellow = '#FFE200'
export const lightYellow = '#fbf1a9'
export const purple = '#5e2ca5'
export const lightPurple = '#a463f2'
export const darkPink = '#d5008f'
export const hotPink = '#ff41b4'
export const pink = '#ff80cc'
export const lightPink = '#ffa3d7'
export const darkGreen = '#137752'
export const green = '#19a974'
export const lightGreen = '#9eebcf'
export const navy = '#001b44'
export const darkBlue = '#00449e'
export const blue = '#357edd'
export const lightBlue = '#96ccff'
export const lightestBlue = '#cdecff'
export const washedBlue = '#f6fffe'
export const washedGreen = '#e8fdf5'
export const washedYellow = '#fffceb'
export const washedRed = '#ffdfdf'



/** WEBPACK FOOTER **
 ** ./src/colors.js
 **/